/// <summary>
/// Reference list of codes identifying standard units of measure, as well as their English names and, when appropriate, conversion factors between them.
/// Uses consistent UOM codes with the server-side UOM utility class.
/// </summary>
var UOM = {
    // imperial weight
    Ounce: "oz",
    Pound: "lb",
    ShortTon: "ton",
    LongTon: "lton",

    // metric mass
    Gram: "g",
    Kilogram: "kg",
    MetricTon: "mton",

    Inch: "in",
    Foot: "ft",
    Yard: "yd",
    Mile: "mi",

    Centimeter: "cm",
    Meter: "m",
    Kilometer: "km",

    Each: "ea",

    Head: "head",

    Gallon: "gal",
    Barrel: "bbl",
    CubicMeter: "m3",

    GrossRegisterTon: "grt",

    // TH 11/15/2016 -- This is NOT the same thing as GrossRegisterTon.
    // GrossRegisterTon is a pure unit of volume - it equals 100 cubic feet.
    // GrossTonnage is a more recent way of measuring the same thing. It's a nonlinear function of total enclosed volume that uses a logarithmic formula.
    // So in theory, one can be derived from the other, but not via a linear conversion.
    // See https://en.wikipedia.org/wiki/Gross_tonnage and https://www.dco.uscg.mil/Portals/9/DCO%20Documents/Marine%20Safety%20Center/Tonnage/TM%20Convention%20-%20Draft%20Text%20Version%20With%20Figures%20TM.5-Circ.6.pdf (search "Regulation 3")
    GrossTonnage: "gt",

    // TH: See http://www.rapidtables.com/convert/power/hp-to-kw.htm and https://en.wikipedia.org/wiki/Horsepower for discussion of the various horsepower units
    Horsepower: "hp", // aka mechanical/hydraulic horsepower, "hp(I)"
    ElectricalHorsepower: "hpE", // aka "hp(E)"
    MetricHorsepower: "hpM", // aka "hp(M)"

    Watt: "W",
    Kilowatt: "kW",

    Name: {} as { [abbr :string] : string },

    Conversion: {} as { [toUom: string] : { [fromUom: string ] : number | undefined }}
};

UOM.Name[UOM.Ounce]     = "ounces";
UOM.Name[UOM.Pound]     = "pounds";
UOM.Name[UOM.ShortTon]  = "tons (US)";
UOM.Name[UOM.LongTon]   = "tons (UK)";

UOM.Name[UOM.Gram]      = "grams";
UOM.Name[UOM.Kilogram]  = "kilograms";
UOM.Name[UOM.MetricTon] = "tons (Metric)";

UOM.Name[UOM.Inch]      = "inches";
UOM.Name[UOM.Foot]      = "feet";
UOM.Name[UOM.Yard]      = "yards";
UOM.Name[UOM.Mile]      = "mile";

UOM.Name[UOM.Centimeter] = "centimeters";
UOM.Name[UOM.Meter]      = "meters";
UOM.Name[UOM.Kilometer]  = "kilometer";

UOM.Name[UOM.Each] = "each";

UOM.Name[UOM.Head] = "head";

UOM.Name[UOM.Gallon]     = "gallons";
UOM.Name[UOM.Barrel]     = "barrels";
UOM.Name[UOM.CubicMeter] = "cubic meter";

UOM.Name[UOM.GrossRegisterTon] = "Gross Register Tons";

UOM.Name[UOM.GrossTonnage] = "gross tonnage";

UOM.Name[UOM.Horsepower]           = "horsepower";
UOM.Name[UOM.ElectricalHorsepower] = "electrical horsepower";
UOM.Name[UOM.MetricHorsepower]     = "metric horsepower";

UOM.Name[UOM.Watt]                 = "watts";
UOM.Name[UOM.Kilowatt]             = "kilowatts";

// Conversion Factors
// Weight
var OuncesPerPound = 16;
var OuncesPerShortTon = 32000;
var OuncesPerLongTon = 35840;
var OuncesPerGram = 0.03527396195;
var OuncesPerKilogram = 35.27396195;
var OuncesPerMetricTon = 35273.96195;

var PoundsPerOunce = 1 / OuncesPerPound;
var PoundsPerShortTon = 2000;
var PoundsPerLongTon = 2240;
var PoundsPerGram = 0.0022046226218;
var PoundsPerKilogram = 2.2046226218;
var PoundsPerMetricTon = 2204.6226218;

var ShortTonsPerOunce = 1 / OuncesPerShortTon;
var ShortTonsPerPound = 1 / PoundsPerShortTon;
var ShortTonsPerLongTon = 1.12;
var ShortTonsPerGram = 0.0000011023113109;
var ShortTonsPerKilogram = 0.0011023113109;
var ShortTonsPerMetricTon = 1.1023113109;

var LongTonsPerOunce = 1 / OuncesPerShortTon;
var LongTonsPerPound = 1 / PoundsPerShortTon;
var LongTonsPerShortTon = 1 / ShortTonsPerLongTon;
var LongTonsPerGram = 9.8420652761e-7;
var LongTonsPerKilogram = 9.8420652761e-4;
var LongTonsPerMetricTon = 0.984206527589;

var GramsPerOunce = 1 / OuncesPerGram;
var GramsPerPound = 1 / PoundsPerGram;
var GramsPerShortTon = 1 / ShortTonsPerGram;
var GramsPerLongTon = 1 / LongTonsPerGram;
var GramsPerKilogram = 1000;
var GramsPerMetricTon = 1000000;

var KilogramsPerOunce = 1 / OuncesPerKilogram;
var KilogramsPerPound = 1 / PoundsPerKilogram;
var KilogramsPerShortTon = 1 / ShortTonsPerKilogram;
var KilogramsPerLongTon = 1 / LongTonsPerKilogram;
var KilogramsPerGram = 1 / GramsPerKilogram;
var KilogramsPerMetricTon = 1000;

var MetricTonsPerOunce = 1 / OuncesPerMetricTon;
var MetricTonsPerPound = 1 / PoundsPerMetricTon;
var MetricTonsPerShortTon = 1 / ShortTonsPerMetricTon;
var MetricTonsPerLongTon = 1 / LongTonsPerMetricTon;
var MetricTonsPerGram = 1 / GramsPerMetricTon;
var MetricTonsPerKilogram = 1 / KilogramsPerMetricTon;

// Length
var InchesPerFoot = 12;
var InchesPerYard = 36;
var InchesPerMile = 63360;
var InchesPerCentimeter = 0.3937007874;
var InchesPerMeter = 39.37007874;
var InchesPerKilometer = 39370.07874;

var FeetPerInch = 1 / InchesPerFoot;
var FeetPerYard = 3;
var FeetPerMile = 5280;
var FeetPerCentimeter = 0.03280839895;
var FeetPerMeter = 3.280839895;
var FeetPerKilometer = 3280.839895;

var YardsPerInch = 1 / InchesPerYard;
var YardsPerFoot = 1 / FeetPerYard;
var YardsPerMile = 1760;
var YardsPerCentimeter = 0.010936132983;
var YardsPerMeter = 1.0936132983;
var YardsPerKilometer = 1093.6132983;

var MilesPerInch = 1 / InchesPerMile;
var MilesPerFoot = 1 / FeetPerMile;
var MilesPerYard = 1 / YardsPerMile;
var MilesPerCentimeter = 0.0000062137119224;
var MilesPerMeter = 0.00062137119224;
var MilesPerKilometer = 0.62137119224;

var CentimetersPerInch = 1 / InchesPerCentimeter;
var CentimetersPerFoot = 1 / FeetPerCentimeter;
var CentimetersPerYard = 1 / YardsPerCentimeter;
var CentimetersPerMile = 1 / MilesPerCentimeter;
var CentimetersPerMeter = 100;
var CentimetersPerKilometer = 100000;

var MetersPerInch = 1 / InchesPerMeter;
var MetersPerFoot = 1 / FeetPerMeter;
var MetersPerYard = 1 / YardsPerMeter;
var MetersPerMile = 1 / MilesPerMeter;
var MetersPerCentimeter = 1 / CentimetersPerMeter;
var MetersPerKilometer = 1000;

var KilometersPerInch = 1 / InchesPerKilometer;
var KilometersPerFoot = 1 / FeetPerKilometer;
var KilometersPerYard = 1 / YardsPerKilometer;
var KilometersPerMile = 1 / MilesPerKilometer;
var KilometersPerCentimeter = 1 / CentimetersPerKilometer;
var KilometersPerMeter = 1 / MetersPerKilometer;

var GallonsPerBarrel = 42;
var GallonsPerCubicMeter = 264.172;
var GallonsPerGrossRegisterTon = 748.052;

var BarrelsPerGallon = 1 / GallonsPerBarrel;
var BarrelsPerCubicMeter = 6.290;
var BarrelsPerGrossRegisterTon = 17.8107619047619;

var CubicMetersPerGallon = 1 / GallonsPerCubicMeter;
var CubicMetersPerBarrel = 0.159;
var CubicMetersPerGrossRegisterTon = 2.832;

var GrossRegisterTonsPerGallon = 1 / GallonsPerGrossRegisterTon;
var GrossRegisterTonsPerBarrel = 1 / BarrelsPerGrossRegisterTon;
var GrossRegisterTonsPerCubicMeter = 1 / CubicMetersPerGrossRegisterTon;

// Power
var WattsPerHorsepower = 745.69987158227;
var WattsPerElectricalHorsepower = 746;
var WattsPerMetricHorsepower = 735.49875;
var WattsPerKilowatt = 1000;

var KilowattsPerHorsepower = WattsPerHorsepower / WattsPerKilowatt;
var KilowattsPerElectricalHorsepower = WattsPerElectricalHorsepower / WattsPerKilowatt;
var KilowattsPerMetricHorsepower = WattsPerMetricHorsepower / WattsPerKilowatt;
var KilowattsPerWatt = 1 / WattsPerKilowatt;

var HorsepowerPerElectricalHorsepower = WattsPerElectricalHorsepower / WattsPerHorsepower;
var HorsepowerPerMetricHorsepower = WattsPerMetricHorsepower / WattsPerHorsepower;
var HorsepowerPerWatt = 1 / WattsPerHorsepower;
var HorsepowerPerKilowatt = 1 / KilowattsPerHorsepower;

var ElectricalHorsepowerPerHorsepower = 1 / HorsepowerPerElectricalHorsepower;
var ElectricalHorsepowerPerMetricHorsepower = WattsPerMetricHorsepower / WattsPerElectricalHorsepower;
var ElectricalHorsepowerPerWatt = 1 / WattsPerElectricalHorsepower;
var ElectricalHorsepowerPerKilowatt = 1 / KilowattsPerElectricalHorsepower;

var MetricHorsepowerPerHorsepower = 1 / HorsepowerPerMetricHorsepower;
var MetricHorsepowerPerElectricalHorsepower = 1 / ElectricalHorsepowerPerMetricHorsepower;
var MetricHorsepowerPerWatt = 1 / WattsPerMetricHorsepower;
var MetricHorsepowerPerKilowatt = 1 / KilowattsPerMetricHorsepower;

UOM.Conversion[UOM.Ounce] = {};
UOM.Conversion[UOM.Ounce][UOM.Ounce] =          1.0;
UOM.Conversion[UOM.Ounce][UOM.Pound] =          OuncesPerPound;
UOM.Conversion[UOM.Ounce][UOM.ShortTon] =       OuncesPerShortTon;
UOM.Conversion[UOM.Ounce][UOM.LongTon] =        OuncesPerLongTon;
UOM.Conversion[UOM.Ounce][UOM.Gram] =           OuncesPerGram;
UOM.Conversion[UOM.Ounce][UOM.Kilogram] =       OuncesPerKilogram;
UOM.Conversion[UOM.Ounce][UOM.MetricTon] =      OuncesPerMetricTon;

UOM.Conversion[UOM.Pound] = {};
UOM.Conversion[UOM.Pound][UOM.Ounce] =          PoundsPerOunce;
UOM.Conversion[UOM.Pound][UOM.Pound] =          1.0;
UOM.Conversion[UOM.Pound][UOM.ShortTon] =       PoundsPerShortTon;
UOM.Conversion[UOM.Pound][UOM.LongTon] =        PoundsPerLongTon;
UOM.Conversion[UOM.Pound][UOM.Gram] =           PoundsPerGram;
UOM.Conversion[UOM.Pound][UOM.Kilogram] =       PoundsPerKilogram;
UOM.Conversion[UOM.Pound][UOM.MetricTon] =      PoundsPerMetricTon;

UOM.Conversion[UOM.ShortTon] = {};
UOM.Conversion[UOM.ShortTon][UOM.Ounce] =       ShortTonsPerOunce;
UOM.Conversion[UOM.ShortTon][UOM.Pound] =       ShortTonsPerPound;
UOM.Conversion[UOM.ShortTon][UOM.ShortTon] =    1.0;
UOM.Conversion[UOM.ShortTon][UOM.LongTon] =     ShortTonsPerLongTon;
UOM.Conversion[UOM.ShortTon][UOM.Gram] =        ShortTonsPerGram;
UOM.Conversion[UOM.ShortTon][UOM.Kilogram] =    ShortTonsPerKilogram;
UOM.Conversion[UOM.ShortTon][UOM.MetricTon] =   ShortTonsPerMetricTon;

UOM.Conversion[UOM.LongTon] = {};
UOM.Conversion[UOM.LongTon][UOM.Ounce] =        LongTonsPerOunce;
UOM.Conversion[UOM.LongTon][UOM.Pound] =        LongTonsPerPound;
UOM.Conversion[UOM.LongTon][UOM.ShortTon] =     LongTonsPerShortTon;
UOM.Conversion[UOM.LongTon][UOM.LongTon] =      1.0;
UOM.Conversion[UOM.LongTon][UOM.Gram] =         LongTonsPerGram;
UOM.Conversion[UOM.LongTon][UOM.Kilogram] =     LongTonsPerKilogram;
UOM.Conversion[UOM.LongTon][UOM.MetricTon] =    LongTonsPerMetricTon;

UOM.Conversion[UOM.Gram] = {};
UOM.Conversion[UOM.Gram][UOM.Ounce] =           GramsPerOunce;
UOM.Conversion[UOM.Gram][UOM.Pound] =           GramsPerPound;
UOM.Conversion[UOM.Gram][UOM.ShortTon] =        GramsPerShortTon;
UOM.Conversion[UOM.Gram][UOM.LongTon] =         GramsPerLongTon;
UOM.Conversion[UOM.Gram][UOM.Gram] =            1.0;
UOM.Conversion[UOM.Gram][UOM.Kilogram] =        GramsPerKilogram;
UOM.Conversion[UOM.Gram][UOM.MetricTon] =       GramsPerMetricTon;

UOM.Conversion[UOM.Kilogram] = {};
UOM.Conversion[UOM.Kilogram][UOM.Ounce] =        KilogramsPerOunce;
UOM.Conversion[UOM.Kilogram][UOM.Pound] =        KilogramsPerPound;
UOM.Conversion[UOM.Kilogram][UOM.ShortTon] =     KilogramsPerShortTon;
UOM.Conversion[UOM.Kilogram][UOM.LongTon] =      KilogramsPerLongTon;
UOM.Conversion[UOM.Kilogram][UOM.Gram] =         KilogramsPerGram;
UOM.Conversion[UOM.Kilogram][UOM.Kilogram] =     1.0;
UOM.Conversion[UOM.Kilogram][UOM.MetricTon] =    KilogramsPerMetricTon;

UOM.Conversion[UOM.MetricTon] = {};
UOM.Conversion[UOM.MetricTon][UOM.Ounce] =       MetricTonsPerOunce;
UOM.Conversion[UOM.MetricTon][UOM.Pound] =       MetricTonsPerPound;
UOM.Conversion[UOM.MetricTon][UOM.ShortTon] =    MetricTonsPerShortTon;
UOM.Conversion[UOM.MetricTon][UOM.LongTon] =     MetricTonsPerLongTon;
UOM.Conversion[UOM.MetricTon][UOM.Gram] =        MetricTonsPerGram;
UOM.Conversion[UOM.MetricTon][UOM.Kilogram] =    MetricTonsPerKilogram;
UOM.Conversion[UOM.MetricTon][UOM.MetricTon] =   1.0;

UOM.Conversion[UOM.Inch] = {};
UOM.Conversion[UOM.Inch][UOM.Inch] =             1.0;
UOM.Conversion[UOM.Inch][UOM.Foot] =             InchesPerFoot;
UOM.Conversion[UOM.Inch][UOM.Yard] =             InchesPerYard;
UOM.Conversion[UOM.Inch][UOM.Mile] =             InchesPerMile;
UOM.Conversion[UOM.Inch][UOM.Centimeter] =       InchesPerCentimeter;
UOM.Conversion[UOM.Inch][UOM.Meter] =            InchesPerMeter;
UOM.Conversion[UOM.Inch][UOM.Kilometer] =        InchesPerKilometer;

UOM.Conversion[UOM.Foot] = {};
UOM.Conversion[UOM.Foot][UOM.Inch] =             FeetPerInch;
UOM.Conversion[UOM.Foot][UOM.Foot] =             1.0;
UOM.Conversion[UOM.Foot][UOM.Yard] =             FeetPerYard;
UOM.Conversion[UOM.Foot][UOM.Mile] =             FeetPerMile;
UOM.Conversion[UOM.Foot][UOM.Centimeter] =       FeetPerCentimeter;
UOM.Conversion[UOM.Foot][UOM.Meter] =            FeetPerMeter;
UOM.Conversion[UOM.Foot][UOM.Kilometer] =        FeetPerKilometer;

UOM.Conversion[UOM.Yard] = {};
UOM.Conversion[UOM.Yard][UOM.Inch] =             YardsPerInch;
UOM.Conversion[UOM.Yard][UOM.Foot] =             YardsPerFoot;
UOM.Conversion[UOM.Yard][UOM.Yard] =             1.0;
UOM.Conversion[UOM.Yard][UOM.Mile] =             YardsPerMile;
UOM.Conversion[UOM.Yard][UOM.Centimeter] =       YardsPerCentimeter;
UOM.Conversion[UOM.Yard][UOM.Meter] =            YardsPerMeter;
UOM.Conversion[UOM.Yard][UOM.Kilometer] =        YardsPerKilometer;

UOM.Conversion[UOM.Mile] = {};
UOM.Conversion[UOM.Mile][UOM.Inch] =             MilesPerInch;
UOM.Conversion[UOM.Mile][UOM.Foot] =             MilesPerFoot;
UOM.Conversion[UOM.Mile][UOM.Yard] =             MilesPerYard;
UOM.Conversion[UOM.Mile][UOM.Mile] =             1.0;
UOM.Conversion[UOM.Mile][UOM.Centimeter] =       MilesPerCentimeter;
UOM.Conversion[UOM.Mile][UOM.Meter] =            MilesPerMeter;
UOM.Conversion[UOM.Mile][UOM.Kilometer] =        MilesPerKilometer;

UOM.Conversion[UOM.Centimeter] = {};
UOM.Conversion[UOM.Centimeter][UOM.Inch] =       CentimetersPerInch;
UOM.Conversion[UOM.Centimeter][UOM.Foot] =       CentimetersPerFoot;
UOM.Conversion[UOM.Centimeter][UOM.Yard] =       CentimetersPerYard;
UOM.Conversion[UOM.Centimeter][UOM.Mile] =       CentimetersPerMile;
UOM.Conversion[UOM.Centimeter][UOM.Centimeter] = 1.0;
UOM.Conversion[UOM.Centimeter][UOM.Meter] =      CentimetersPerMeter;
UOM.Conversion[UOM.Centimeter][UOM.Kilometer] =  CentimetersPerKilometer;

UOM.Conversion[UOM.Meter] = {};
UOM.Conversion[UOM.Meter][UOM.Inch] =            MetersPerInch;
UOM.Conversion[UOM.Meter][UOM.Foot] =            MetersPerFoot;
UOM.Conversion[UOM.Meter][UOM.Yard] =            MetersPerYard;
UOM.Conversion[UOM.Meter][UOM.Mile] =            MetersPerMile;
UOM.Conversion[UOM.Meter][UOM.Centimeter] =      MetersPerCentimeter;
UOM.Conversion[UOM.Meter][UOM.Meter] =           1.0;
UOM.Conversion[UOM.Meter][UOM.Kilometer] =       MetersPerKilometer;

UOM.Conversion[UOM.Kilometer] = {};
UOM.Conversion[UOM.Kilometer][UOM.Inch] =        KilometersPerInch;
UOM.Conversion[UOM.Kilometer][UOM.Foot] =        KilometersPerFoot;
UOM.Conversion[UOM.Kilometer][UOM.Yard] =        KilometersPerYard;
UOM.Conversion[UOM.Kilometer][UOM.Mile] =        KilometersPerMile;
UOM.Conversion[UOM.Kilometer][UOM.Centimeter] =  KilometersPerCentimeter;
UOM.Conversion[UOM.Kilometer][UOM.Meter] =       KilometersPerMeter;
UOM.Conversion[UOM.Kilometer][UOM.Kilometer] =   1.0;

UOM.Conversion[UOM.Each] = {};
UOM.Conversion[UOM.Each][UOM.Each] =             1.0;

UOM.Conversion[UOM.Head] = {};
UOM.Conversion[UOM.Head][UOM.Head] =             1.0;

UOM.Conversion[UOM.Gallon] = {};
UOM.Conversion[UOM.Gallon][UOM.Gallon] =            1.0;
UOM.Conversion[UOM.Gallon][UOM.Barrel] =            GallonsPerBarrel;
UOM.Conversion[UOM.Gallon][UOM.CubicMeter] =        GallonsPerCubicMeter;
UOM.Conversion[UOM.Gallon][UOM.GrossRegisterTon] =  GallonsPerGrossRegisterTon;

UOM.Conversion[UOM.Barrel] = {};
UOM.Conversion[UOM.Barrel][UOM.Barrel] =            1.0;
UOM.Conversion[UOM.Barrel][UOM.Gallon] =            BarrelsPerGallon;
UOM.Conversion[UOM.Barrel][UOM.CubicMeter] =        BarrelsPerCubicMeter;
UOM.Conversion[UOM.Barrel][UOM.GrossRegisterTon] =  BarrelsPerGrossRegisterTon;

UOM.Conversion[UOM.CubicMeter] = {};
UOM.Conversion[UOM.CubicMeter][UOM.CubicMeter] =       1.0;
UOM.Conversion[UOM.CubicMeter][UOM.Barrel] =           CubicMetersPerBarrel;
UOM.Conversion[UOM.CubicMeter][UOM.Gallon] =           CubicMetersPerGallon;
UOM.Conversion[UOM.CubicMeter][UOM.GrossRegisterTon] = CubicMetersPerGrossRegisterTon;

UOM.Conversion[UOM.GrossRegisterTon] = {};
UOM.Conversion[UOM.GrossRegisterTon][UOM.GrossRegisterTon] = 1.0;
UOM.Conversion[UOM.GrossRegisterTon][UOM.Gallon]           = GrossRegisterTonsPerGallon;
UOM.Conversion[UOM.GrossRegisterTon][UOM.Barrel]           = GrossRegisterTonsPerBarrel;

UOM.Conversion[UOM.GrossTonnage] = {};
UOM.Conversion[UOM.GrossTonnage][UOM.GrossTonnage] = 1.0;

UOM.Conversion[UOM.Watt] = {};
UOM.Conversion[UOM.Watt][UOM.Horsepower] =                           WattsPerHorsepower;
UOM.Conversion[UOM.Watt][UOM.ElectricalHorsepower] =                 WattsPerElectricalHorsepower;
UOM.Conversion[UOM.Watt][UOM.MetricHorsepower] =                     WattsPerMetricHorsepower;
UOM.Conversion[UOM.Watt][UOM.Watt] =                                 1.0;
UOM.Conversion[UOM.Watt][UOM.Kilowatt] =                             WattsPerKilowatt;

UOM.Conversion[UOM.Kilowatt] = {};
UOM.Conversion[UOM.Kilowatt][UOM.Horsepower] =                       KilowattsPerHorsepower;
UOM.Conversion[UOM.Kilowatt][UOM.ElectricalHorsepower] =             KilowattsPerElectricalHorsepower;
UOM.Conversion[UOM.Kilowatt][UOM.MetricHorsepower] =                 KilowattsPerMetricHorsepower;
UOM.Conversion[UOM.Kilowatt][UOM.Watt] =                             KilowattsPerWatt;
UOM.Conversion[UOM.Kilowatt][UOM.Kilowatt] =                         1.0;

UOM.Conversion[UOM.Horsepower] = {};
UOM.Conversion[UOM.Horsepower][UOM.Horsepower] =                     1.0;
UOM.Conversion[UOM.Horsepower][UOM.ElectricalHorsepower] =           HorsepowerPerElectricalHorsepower;
UOM.Conversion[UOM.Horsepower][UOM.MetricHorsepower] =               HorsepowerPerMetricHorsepower;
UOM.Conversion[UOM.Horsepower][UOM.Watt] =                           HorsepowerPerWatt;
UOM.Conversion[UOM.Horsepower][UOM.Kilowatt] =                       HorsepowerPerKilowatt;

UOM.Conversion[UOM.ElectricalHorsepower] = {};
UOM.Conversion[UOM.ElectricalHorsepower][UOM.Horsepower] =           ElectricalHorsepowerPerHorsepower;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.ElectricalHorsepower] = 1.0;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.MetricHorsepower] =     ElectricalHorsepowerPerMetricHorsepower;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.Watt] =                 ElectricalHorsepowerPerWatt;
UOM.Conversion[UOM.ElectricalHorsepower][UOM.Kilowatt] =             ElectricalHorsepowerPerKilowatt;

UOM.Conversion[UOM.MetricHorsepower] = {};
UOM.Conversion[UOM.MetricHorsepower][UOM.Horsepower] =               MetricHorsepowerPerHorsepower;
UOM.Conversion[UOM.MetricHorsepower][UOM.ElectricalHorsepower] =     MetricHorsepowerPerElectricalHorsepower;
UOM.Conversion[UOM.MetricHorsepower][UOM.MetricHorsepower] =         1.0;
UOM.Conversion[UOM.MetricHorsepower][UOM.Watt] =                     MetricHorsepowerPerWatt;
UOM.Conversion[UOM.MetricHorsepower][UOM.Kilowatt] =                 MetricHorsepowerPerKilowatt;

export default UOM;



// WEBPACK FOOTER //
// ./lib/UOM.ts